$(function () {
  const $stickyJumpNav = $('.sticky-jump-nav')
  
  if ($stickyJumpNav.length) {

    const navDistanceTop = $stickyJumpNav.offset().top

    if (window.matchMedia('(max-width: 991px)').matches) {
      $('.sticky-jump-nav__link').on('click touch', e => e.preventDefault())
      
      const $stickyJumpCarousel = $('.sticky-jump-nav__list').slick({
        accessibility: false,
        arrows: false,
        infinite: false,
        mobileFirst: true,
        centerMode: true,
        touchMove: false,
        centerPadding: '0px',
        focusOnSelect: true,
        variableWidth: true,
      })

      // $(window).on('load resize scroll', () => {
      //   $.each($('.scrollspy'), (i, el) => {
      //     const id = $(el).attr('id')
      //     const anchor = `#${id}`
      //     const scroll = window.scrollspy[anchor]
      //     if (window.scrollY >= (scroll.top - 5) && window.scrollY <= (scroll.bot - 5)) {
      //       $stickyJumpCarousel.slick('slickGoTo', $(`[href="${anchor}"]`).parent().data('slick-index'))
      //     }
      //   })
      // })
    }

    $(window).on('load resize scroll', () => {
      if (window.scrollY >= navDistanceTop) {
        $stickyJumpNav.addClass('sticky-jump-nav--is-scrolled')
      } else {
        $stickyJumpNav.removeClass('sticky-jump-nav--is-scrolled')
      }
    })
  }
})